// extracted by mini-css-extract-plugin
var _1 = "tQk5EucUNW1BN45V0fLe";
var _2 = "Fg_3PYVEJHM5y7KOpJse";
var _3 = "iSuLzOHilERl6I1sjV00";
var _4 = "tQ6YeWzve4xU2Fq0dMfV";
var _5 = "KrNKfSwr8_Xw5G84Qvtj";
var _6 = "m3wNyqbHSE5XAKfhyRJo";
export { _1 as "highlighted", _2 as "item", _3 as "menu", _4 as "note", _5 as "secondary", _6 as "wrapper" }
